import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconPageEdit: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="page-edit, document"><path d="M10.75 21.25H4.75V2.75H19.25V11.75" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M13.75 21.2502V18.9168L17.5 15.1668C18.1443 14.5225 19.189 14.5225 19.8333 15.1668C20.4777 15.8112 20.4777 16.8558 19.8333 17.5002L16.0833 21.2502H13.75Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/></CentralIconBase>;
};

export default IconPageEdit;
